import { PlatformDependencies } from '@citrite/workspace-ui-platform';
import { ConfigurationService } from 'Configuration/ConfigurationService';
import { container } from 'Workspace/DependencyManagement';

export * from 'Configuration/ConfigurationService';
export * from 'Configuration/accessors';

export function getConfigurationService(): ConfigurationService {
	const workspaceConfiguration = container
		.resolve(PlatformDependencies.WorkspaceConfiguration)
		.get();
	return new ConfigurationService(workspaceConfiguration);
}
